export default __webpack_public_path__ + "static/Litepaper - Italian-74ea859c99c074112f68f6f0db6bb067.pdf";